//messages.js
export default {
    manage_tag: "Manage Tag",
    create_tag: "Create Tag",
    remove_tag: "Remove Tag",
    remove: "Remove",
    confirm_remove_message: "Are you sure you want to remove?",
    attach_existing: "Attach Existing",
    device_count: "Device Count",

    tag: "Tag",
    edit_tag: "Edit Tag",
    add_tag: "Add Tag",
    delete_tag: "Delete Tag",
    tags: "Tags",
    delete_tag_confirm: "This action is not reversible!",
};
